<!--
SPDX-FileCopyrightText: 2023 Marlon W (Mawoka)

SPDX-License-Identifier: MPL-2.0
-->

<script lang="ts">
	import LanguageToggle from './language-toggle.svelte';
	import { getLocalization } from '$lib/i18n';

	const { t } = getLocalization();
</script>

<footer class="text-center w-screen" style="color: var(--theme-text);">
	<div class="grid grid-cols-12 w-full pt-4 pb-2" style="background-color: var(--theme-surface); border-top: 1px solid var(--theme-border);">
		<p class="col-start-3 col-end-11 text-center w-full">
			<!--
				Раньше здесь стояла реклама и сбор пожертвований автору исходного проекта: наш
				сервис просил денег для чужого человека. Лицензия MPL-2.0 этого не требует — она
				охраняет уведомления в ИСХОДНОМ КОДЕ (заголовки SPDX и файл LICENSE, они на месте),
				а не подпись в интерфейсе. Осталось честное упоминание основы со ссылкой на неё.
			-->
			{@html $t('footer.based_on', {
				upstream_link:
					'<a href="https://github.com/mawoka-myblock/ClassQuiz" target="_blank" class="underline footer-link transition">ClassQuiz</a>',
				license_link:
					'<a href="https://www.mozilla.org/en-US/MPL/2.0/" target="_blank" class="underline footer-link transition">MPL-2.0</a>',
				interpolation: { escapeValue: false }
			})}
		</p>
		<div
			class="flex flex-col items-center min-h-full h-full md:block hidden col-start-11 col-end-12"
		>
			<div class="my-auto mr-16">
				<LanguageToggle />
			</div>
		</div>
	</div>
	<div class="md:hidden block">
		<div class="self-end flex justify-center min-h-full h-full pb-2 md:pb-0" style="background-color: var(--theme-surface);">
			<div class="m-auto md:invisible visible">
				<LanguageToggle />
			</div>
		</div>
	</div>

	<!-- 🔴 УБРАН ПРИЗЫВ СЛЕДИТЬ ЗА ЧУЖИМ АККАУНТОМ (29.08.2026). На КАЖДОЙ
	     странице нашего сайта стояло «подпишитесь на @classquiz@fosstodon.org,
	     чтобы узнавать новости» — аккаунт автора исходного проекта. Ссылки на
	     пожертвования ему убрали 26.08 по той же причине: наш сайт не уводит
	     наших учителей к чужому продукту. -->

</footer>

<style>
	.footer-link {
		color: var(--theme-primary);
		opacity: 0.85;
	}
	.footer-link:hover {
		opacity: 1;
		filter: brightness(1.2);
	}
</style>
